var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.currentComponent,{tag:"component",attrs:{"id":_vm.routeParams.id},on:{"changeNotification":_vm.changeNotification}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }